import { useEffect, useState } from "react";
import { ModalButton } from "../project/style";
import { Catalogs } from "./index";
import { Modal, ModalBody, ModalFooter, Spinner } from "reactstrap";

const CatalogsModal = ({ isOpen, toggle, handleAddItem, loading }) => {
  const [selectedCatalog, setSelectedCatalog] = useState(null);

  return (
    <Modal isOpen={isOpen} toggle={toggle} backdrop="static">
      <ModalBody className="p-0">
        <div className="row catalogs-modal">
          <Catalogs
            carpenterView={true}
            setSelectedCatalog={setSelectedCatalog}
            selectedCatalog={selectedCatalog}
          />
        </div>
      </ModalBody>
      <ModalFooter className="pt-0 border-0 mt-3">
        <ModalButton
          className="mt-0"
          color="primary"
          onClick={() => handleAddItem(selectedCatalog)}
        >
          {loading ? <Spinner size={"sm"}>Loading...</Spinner> : "Add"}
        </ModalButton>
        <ModalButton
          className="mt-0"
          color="secondary"
          onClick={() => {
            toggle();
          }}
        >
          Cancel
        </ModalButton>
      </ModalFooter>
    </Modal>
  );
};

export default CatalogsModal;
